import { useState } from 'react'
import { useStore } from 'react-redux'
import { toast } from 'react-toastify'
import { orderDetailsRequested } from '../../../actions/order'

import MutationApi from '../../../remote/mutationApi'

const useRemovePayment = () => {
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)
  const [failed, setFailed] = useState(false)
  const store = useStore()

  const executeRequest = (orderId, paymentId) => {
    setLoading(true)
    setSuccess(false)
    setFailed(false)

    MutationApi.removePayment(orderId, paymentId).then((result) => {
      const applied = result?.data?.orderMutations?.[0]?.applied
      setLoading(false)

      if (applied) {
        setSuccess(true)
        setFailed(false)

        store.dispatch(orderDetailsRequested(orderId))
      } else {
        setSuccess(false)
        setFailed(true)
      }
    }).catch((err) => {
      setLoading(false)
      setSuccess(false)
      setFailed(true)
    })
  }

  return [executeRequest, { loading, success, failed }]
}

export default useRemovePayment
